
import React from 'react';

interface StyledBulletPointProps {
  children: React.ReactNode;
}

const StyledBulletPoint: React.FC<StyledBulletPointProps> = ({ children }) => {
  return (
    <div className="flex items-start space-x-2">
      <div>
        <span style={{ color: "#8e44ad" }}>🔹</span>
      </div>
      <div>{children}</div>
    </div>
  );
};

export default StyledBulletPoint;
